<template>
  <!--
    SLOTS
      - NORMAL - hides the area given the slot, press the button to view the slotted area
  -->
  <div class="pull-down-button" :style="canvasStyle">
    <div class="pull-down-button__canvas" :style="{'width': width + 'px'}">
      <div v-if="show">
        <div class="pull-down-button__canvas-shown">
          <scroll-panel :height="scrollHeight">
            <slot></slot>
          </scroll-panel>
        </div>
      </div>
    </div>
      <div class="pull-down-button__button-area">
        <div @click="toggleHiddenSection"
          class="pull-down-button__button"
          ref="button"
          :style="buttonPosition">
          <b>{{text}}</b>
          <icon v-if="show" name="caret-up" class="pull-down-button__arrowPosition" scale="1.2"></icon>
          <icon v-else name="caret-down" class="pull-down-button__arrowPosition" scale="1.2"></icon>
        </div>
      </div>
    </div>
</template>

<script>
import ScrollPanel from '@/components/common/scrollPanel'
import 'vue-awesome/icons/caret-down'
import 'vue-awesome/icons/caret-up'
import Icon from 'vue-awesome/components/Icon'

export default {
  components: {
    ScrollPanel,
    Icon
  },
  props: {
    text: String,
    scrollHeight: {
      type: Number,
      default: 480
    },
    width: {
      type: Number,
      default: 500
    }
  },
  data () {
    return {
      show: false,
      buttonPosition: {},
      canvasStyle: {}
    }
  },
  methods: {
    toggleHiddenSection () {
      this.show = !this.show
      this.setCanvisStyle()
    },
    getButtonSize () {
      return this.$refs.button ? this.$refs.button.clientWidth : 0
    },
    setButtonPosition () {
      const centerOfPanel = this.width / 2
      const centerOfButton = this.getButtonSize() / 2
      this.buttonPosition = {
        left: String(centerOfPanel - centerOfButton) + 'px'
      }
    },
    setCanvisStyle () {
      this.canvasStyle = {'z-index': this.show ? 109 : 110}
    }
  },
  mounted () {
    this.setButtonPosition()
    this.setCanvisStyle()
  },
  watch: {
    width () {
      this.setButtonPosition()
    }
  }
}
</script>

<style lang="scss">

.pull-down-button {
  position: fixed;
  $shadow: 1px;

  &__canvas {
    max-height: 500px;
    width: 500px;
    box-sizing: border-box;
    @include drop-shadow;
    background-color: white;
    padding: 0px 0px 0px 15px;
  }

  &__canvas-shown {
    padding-top: 10px;
  }

  &__arrowPosition {
    position: relative;
    left: 10px;
    bottom: 3px;
  }

  &__button {
    position: absolute;
    border-bottom-left-radius: 40px;
    border-bottom-right-radius: 40px;
    background-color: #232a32;
    color: white;
    padding-left: 20px;
    padding-right: 25px;
    font-size: 0.8em;
    line-height: 5px;
    b {
      bottom: 7px;
      position: relative;
    }
  }
}
</style>



// WEBPACK FOOTER //
// PullDownButton.vue?78c0fbb2